<template>
  <modal
    :name="'rate-limit-reached'"
    :adaptive="true"
    :classes="['v--modal', 'rate-limit-reached-modal']"
    :click-to-close="false"
    :height="'auto'"
    :reset="true"
    :scrollable="true"
    :width="'90%'"
    @before-open="beforeOpen"
    @closed="routeToLastDashboard"
  >
    <button
      class="close"
      aria-label="close"
      @click="close"
    >
      <icon name="cross-thin" />
    </button>
    <div class="counter">
      0
    </div>
    <p class="title">
      {{ title }}
    </p>
    <hlt-text class="description">
      {{ description }}
    </hlt-text>
    <button
      class="primary-action-button"
      @click="primaryButtonClicked"
    >
      {{ primaryButtonText }}
    </button>
  </modal>
</template>

<script>
import HltText from '@/components/ui/text.vue';
import Icon from '@/components/singletons/icon.vue';

import RateLimitMixin from '@/mixins/rate-limit';

export default {
  components: {
    HltText,
    Icon,
  },
  mixins: [RateLimitMixin],
  data() {
    return {
      category: null,
      flashcard: null,
      description: null,
      primaryButtonText: null,
      title: null,
      defaultDescription: 'That’s all of your free questions for today, but you can get unlimited access at the button.',
      defaultPrimaryButtonText: 'Unlock Unlimited',
      defaultTitle: 'You\'re on a Roll',
    };
  },
  methods: {
    beforeOpen({ params }) {
      if (!params?.category) {
        return;
      }
      this.category = params.category;
      this.flashcard = params.flashcard;
      const analyticParams = {
        flashcardId: params.flashcard?.id,
        maxCredits: this.rateLimitingCycleCredits,
      };
      this.$analytics.events.viewedRateLimitModal(analyticParams);

      let includedInPOs = [];
      const user = this.$store.getters['user/get'];
      const userCatalogEnabled = user?.catalogPricingEnabled;
      if (user && userCatalogEnabled && params?.category?.id) {
        const resource = this.$store.getters['categories/categories'][params.category.id];
        if (resource) {
          const rootPurchaseOrders = this.$store.getters['purchaseOrders/rootAddon'];
          rootPurchaseOrders.forEach(po => {
            const included = resource?.unlockedBy?.includes(po.id);
            if (included) {
              includedInPOs.push(po.id);
            }
          });
        }
      }

      const page = this.$store.getters['catalog/pageList'].find(page => {
        const canPurchasePage = user?.previewer ? true : page.purchaseEnabled;
        return canPurchasePage && page.visibility && includedInPOs.includes(page.purchaseOrderId);
      });

      const pvar = this.$store.getters['productVars/get']['rateLimitModalConfig'];
      const parsedPVar = pvar?.parsedValue || {};

      this.description = page?.rateLimitSubtitle || parsedPVar.description || this.defaultDescription;
      this.primaryButtonText = page?.rateLimitAffirmativeButtonText || parsedPVar['button_positive'] || this.defaultPrimaryButtonText;
      this.title = page?.rateLimitTitle || parsedPVar.title || this.defaultTitle;
    },
    close() {
      const analyticParams = {
        flashcardId: this.flashcard?.id,
        maxCredits: this.rateLimitingCycleCredits,
      };
      this.$analytics.events.dismissedRateLimitModal(analyticParams);
      this.category = null;
      this.flashcard = null;
      this.$modal.hide('rate-limit-reached');
    },
    primaryButtonClicked() {
      const params = {
        show: true,
        resource: {
          type: 'category',
          id: this.category?.id,
        },
        source: {
          type: 'Rate Limit Modal',
        },
      };
      this.$store.dispatch('ui/toggleUpsellModal', params);
    },
    routeToLastDashboard() {
      let route = { name: 'home' };
      const lastVisitedDashboardId = this.$store.getters['dashboards/lastVisitedId'];
      if (Array.isArray(lastVisitedDashboardId) && lastVisitedDashboardId?.length > 0) {
        route = {
          name: 'dashboard#show',
          params: {
            dashboardId: lastVisitedDashboardId[lastVisitedDashboardId.length - 1],
          },
        };
      }
      this.$router.push(route);
    },
  },
};
</script>

<style lang="scss">
.v--modal.rate-limit-reached-modal {
  border-radius: 8px;
  margin: 0 auto;
  margin-top: calc(50vh - 250px);
  max-width: 450px;
  padding: rem-calc(32);
  text-align: center;

  @include breakpoint(small) {
    margin: rem-calc(20) 0 !important;
    padding: rem-calc(16);
  }

  .close {
    right: rem-calc(16);
    position: absolute;
    top: rem-calc(16);
    background: transparent;
    border: none;
    padding: 0;

    img {
      height: rem-calc(12);
      width: rem-calc(12);

      @include breakpoint(small) {
        height: rem-calc(12);
        width: rem-calc(12);
      }
    }
  }

  .counter {
    align-items: center;
    border: 5px solid #00d9fa;
    border-radius: 100%;
    display: flex;
    font-size: 22px;
    font-weight: $semi-bold;
    height: 66px;
    justify-content: center;
    margin: 44px auto 0;
    width: 66px;
  }

  .title {
    margin-bottom: 8px;
    margin-top: 47px;
    padding: 0;
    font-size: 26px;
    font-weight: $bold;
  }

  .title,
  .description {
    margin-right: 24px;
    margin-left: 24px;
  }

  .primary-action-button {
    background: #E98726;
    border-radius: 24px;
    color: #ffffff;
    font-size: 14px;
    font-weight: $bold;
    margin-bottom: 32px;
    margin-top: 32px;
    padding: 14px 0;
    text-transform: uppercase;
    width: 90%;
  }
}
</style>
